﻿﻿export interface IMatchCounts {
    date: Date;
    dateFormatted: string;
    aboDdMatchesForA: number;
    aboDdMatchesForAb: number;
    aboDdMatchesForB: number;
    aboDdMatchesForO: number;
    aboNddMatchesForA: number;
    aboNddMatchesForAb: number;
    aboNddMatchesForB: number;
    aboNddMatchesForO: number;
    aboTotalMatchesForO: number;
    aboTotalMatchesForA: number;
    aboTotalMatchesForB: number;
    aboTotalMatchesForAb: number;
}
